export const CONTENT_DEFAULTS = {
  site_phone_display: "0480 554 777",
  site_phone_href: "tel:+61480554777",
  site_email: "admin@modifywa.au",
  home_hero_line1: "WE CARE ABOUT",
  home_hero_line2: "SAFER LIVING.",
  home_hero_sub: "Grab rails, hand rails and rubber ramps — supplied and professionally installed across Perth.",
  home_about_p1: "Modify is a Perth-based specialist focused on one thing: making everyday living safer with grab rails, hand rails and rubber ramps.",
  home_about_p2: "We understand that installing a grab rail or hand rail is rarely just about hardware. It's about feeling confident and independent in your own home — stepping into the shower without worry, or getting through the front door with ease.",
  home_about_p3: "Practical safety solutions for greater confidence at home. That's what we care about.",
  home_final_title: "MAKE YOUR HOME SAFER TODAY.",
  home_final_copy: "From grab rails and hand rails to practical rubber ramp solutions, Modify provides simple safety solutions with professional installation across Perth.",
  meta_home_title: "Grab Rails, Hand Rails & Rubber Ramps Perth | Modify — We Care",
  meta_home_desc: "Modify specialises in grab rails, hand rails and rubber ramps — supplied and professionally installed across Perth, WA. Get a quote today.",
  meta_grab_title: "Grab Rail Installation Perth | Supplied & Professionally Installed — Modify",
  meta_grab_desc: "Grab rails supplied and professionally installed across Perth, WA. Bathroom, shower, toilet and wall-mounted grab rails. Get installed today with Modify.",
  meta_hand_title: "Hand Rail Installation Perth | Supplied & Professionally Installed — Modify",
  meta_hand_desc: "Practical hand rail solutions supplied and professionally installed across Perth, WA. Hand rails for stairs, entrances, pathways and steps. Get a quote from Modify.",
  meta_ramps_title: "Rubber Ramps Perth | Supplied & Professionally Installed — Modify",
  meta_ramps_desc: "Practical rubber ramp solutions for suitable steps, thresholds and everyday access across Perth, WA. Get a quote from Modify today.",
  meta_gallery_title: "Our Recent Work | Grab Rails, Hand Rails & Rubber Ramps Perth — Modify",
  meta_gallery_desc: "A look at some of the grab rail, hand rail and rubber ramp solutions Modify has supplied and installed across Perth, WA.",
  meta_reviews_title: "Customer Reviews | Modify — Grab Rails, Hand Rails & Rubber Ramps Perth",
  meta_reviews_desc: "Read what Perth customers say about Modify's grab rail, hand rail and rubber ramp installations. 5-star service, real customer experiences.",
  meta_contact_title: "Contact Modify | Grab Rails, Hand Rails & Rubber Ramps Perth",
  meta_contact_desc: "Have a question about grab rails, hand rails or rubber ramps? Get in touch with Modify — servicing Perth, Western Australia. Call or request a quote online.",
};

export const CONTENT_FIELDS = [
  {
    group: "Contact details",
    hint: "Shown in the header, footer and contact page.",
    fields: [
      { key: "site_phone_display", label: "Phone number (display)" },
      { key: "site_phone_href", label: "Phone link (tel:…)" },
      { key: "site_email", label: "Email address" },
    ],
  },
  {
    group: "Homepage",
    hint: "Main homepage wording.",
    fields: [
      { key: "home_hero_line1", label: "Hero headline — line 1" },
      { key: "home_hero_line2", label: "Hero headline — line 2" },
      { key: "home_hero_sub", label: "Hero supporting text", multiline: true },
      { key: "home_about_p1", label: "We Care story — paragraph 1", multiline: true },
      { key: "home_about_p2", label: "We Care story — paragraph 2", multiline: true },
      { key: "home_about_p3", label: "We Care story — closing line", multiline: true },
      { key: "home_final_title", label: "Final CTA headline" },
      { key: "home_final_copy", label: "Final CTA text", multiline: true },
    ],
  },
  {
    group: "SEO — page titles",
    hint: "Browser tab title shown in Google search results.",
    fields: [
      { key: "meta_home_title", label: "Home — title" },
      { key: "meta_grab_title", label: "Grab Rails — title" },
      { key: "meta_hand_title", label: "Hand Rails — title" },
      { key: "meta_ramps_title", label: "Rubber Ramps — title" },
      { key: "meta_gallery_title", label: "Gallery — title" },
      { key: "meta_reviews_title", label: "Reviews — title" },
      { key: "meta_contact_title", label: "Contact — title" },
    ],
  },
  {
    group: "SEO — page descriptions",
    hint: "The short summary shown under the title in Google search results.",
    fields: [
      { key: "meta_home_desc", label: "Home — description", multiline: true },
      { key: "meta_grab_desc", label: "Grab Rails — description", multiline: true },
      { key: "meta_hand_desc", label: "Hand Rails — description", multiline: true },
      { key: "meta_ramps_desc", label: "Rubber Ramps — description", multiline: true },
      { key: "meta_gallery_desc", label: "Gallery — description", multiline: true },
      { key: "meta_reviews_desc", label: "Reviews — description", multiline: true },
      { key: "meta_contact_desc", label: "Contact — description", multiline: true },
    ],
  },
];
